export const firebaseConfig = {
  "projectId": "studio-2916828899-aeb98",
  "appId": "1:730273376700:web:20f3f8ac2b81ec4e2d23b9",
  "apiKey": "AIzaSyBbBJX1pLlAtHGymyhdaKtQNjOARPO610c",
  "authDomain": "studio-2916828899-aeb98.firebaseapp.com",
  "storageBucket": "studio-2916828899-aeb98.firebasestorage.app",
  "measurementId": "",
  "messagingSenderId": "730273376700"
};
